<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="page_ix"></a>
<p class="noindent1t"><b>APPLICATION FOR EMPLOYMENT</b></p>
<p class="noindent1"><b>NAME:</b><span class="font1"> Ishtar</span></p>
<p class="noindent1"><b>OCCUPATION:</b><span class="font1"> Mother Goddess</span></p>
<p class="noindent1"><b>MARITAL STATUS:</b><span class="font1"> Mother/Harlot/Maiden/Wife</span></p>
<p class="noindent2"><b>PRESENT ADDERESS:</b><span class="font1"> In transit. (Temporary address; Syracuse, New York)</span></p>
<p class="noindent1"><b>AGE:</b><span class="font1"> <img alt="images" src="images/f0011-01.jpg" style="vertical-align: middle;width: 30%"/> (E=MC<sup>2</sup>) (F=MA)?</span></p>
<p class="noindent1"><b>CHILDREN:</b><span class="font1"> same as above</span></p>
<p class="noindent1"><b>EDUCATIONAL DATA:</b><span class="font1"> self-taught</span></p>
<p class="noindent2"><b>SOCIAL/COMMUNITY ACTIVITIES:</b><span class="font1"> Laying of cornerstones, setting of foundations, sacred prostitution (organizer, etc., etc…)</span></p>
<p class="noindent2"><b>SPECIAL HONORS:</b><span class="font1"> Star of David, Star of Solomon, Star of Bethlehem, Eastern Star (Grand Worthy Matron)</span></p>
<p class="noindent3"><b>RECORD OF EMPLOYMENT:</b><span class="font1"> (Please record employment dates in chronological order)</span></p>
<p class="noindent1"><b>TITLE:</b><span class="font1"> Queen of Heaven</span></p>
<p class="noindent1"><b>PLACE OF EMPLOYMENT:</b><span class="font1"> Galaxy</span></p>
<p class="noindent1"><b>DATES:</b><span class="font1"> 4,800,000,000 - 9000 B.C.</span></p>
<p class="noindent2"><b>MAJOR RESPONSIBILITIES:</b><span class="font1"> Fashioning stars, worlds, suns, people (everything, etc.) Prime moving</span></p>
<p class="noindent1"><b>REASON FOR TERMINATION:</b><span class="font1"> Project completed</span></p>
<p class="noindent1"><b>SALARY:</b><span class="font1"> Original Title</span></p>
<a id="page_x"></a>
<p class="noindent4"><b>TITLE:</b><span class="font1"> Angel of Death</span></p>
<p class="noindent1"><b>PLACE OF EMPLOYMENT:</b><span class="font1"> Heaven</span></p>
<p class="noindent1"><b>DATES:</b><span class="font1"> April 9000 B.C.</span></p>
<p class="noindent1"><b>MAJOR RESPONSIBILITIES:</b><span class="font1"> General conflagration, boils, etc…</span></p>
<p class="noindent1"><b>REASON FOR TERMINATION:</b><span class="font1"> Reorganization of Personnel</span></p>
<p class="noindent1"><b>SALARY:</b><span class="font1"> Peace/Quiet/Rest - Sabbatical</span></p>
<p class="noindent4"><b>TITLE:</b><span class="font1"> Queen of Heaven</span></p>
<p class="noindent1"><b>PLACE OF EMPLOYMENT:</b><span class="font1"> above</span></p>
<p class="noindent1"><b>DATES:</b><span class="font1"> 9000 B.C. - 4501 B.C.</span></p>
<p class="noindent1"><b>MAJOR RESPONSIBILITIES:</b><span class="font1"> Birth, love, death, disease, seasons, etc.</span></p>
<p class="noindent1"><b>REASON FOR TERMINATION:</b><span class="font1"> Company failed to maintain initial commitment</span></p>
<p class="noindent1"><b>SALARY:</b><span class="font1"> Adoration/Worship/Respect</span></p>
<p class="noindent4"><b>TITLE:</b><span class="font1"> Angel of Death</span></p>
<p class="noindent1"><b>PLACE OF EMPLOYMENT:</b><span class="font1"> above</span></p>
<p class="noindent1"><b>DATES:</b><span class="font1"> April 4501 B.C.</span></p>
<p class="noindent1"><b>MAJOR RESPONSIBILITIES:</b><span class="font1"> Flood engineer, Passover, Killing of 1st born, plagues</span></p>
<p class="noindent1"><b>REASON FOR TERMINATION:</b><span class="font1"> Cut-back in territory and personnel</span></p>
<p class="noindent1"><b>SALARY:</b><span class="font1"> Peace/Quiet</span></p>
<a id="page_xi"></a>
<p class="noindent4"><b>TITLE:</b><span class="font1"> Queen of Heaven</span></p>
<p class="noindent1"><b>PLACE OF EMPLOYMENT:</b><span class="font1"> Heaven</span></p>
<p class="noindent1"><b>DATES:</b><span class="font1"> 4501 B.C. - 1350 B.C.</span></p>
<p class="noindent1"><b>MAJOR RESPONSIBILITIES:</b><span class="font1"> Birth, love, death augury, disease, changing of seasons, alphabets</span></p>
<p class="noindent1"><b>REASON FOR TERMINATION:</b><span class="font1"> Personality differences (Moses &amp; Monotheism)</span></p>
<p class="noindent1"><b>SALARY:</b><span class="font1"> Adoration, cakes and incense</span></p>
<p class="noindent4"><b>TITLE:</b><span class="font1"> Whore of Babylon (unemployed)</span></p>
<p class="noindent1"><b>PLACE:</b><span class="font1"> wilderness</span></p>
<p class="noindent1"><b>MAJOR RESPONSIBILITIES:</b><span class="font1"> Birth, love, disease, changing of seasons</span></p>
<p class="noindent1"><b>REASON FOR TERMINATION:</b><span class="font1"> Still working</span></p>
<p class="noindent1"><b>SALARY:</b><span class="font1"> Scorn and Calumny</span></p>
<p class="noindent4"><b>DO NOT WRITE BELOW. THIS SPACE FOR OFFICIAL USE ONLY</b><span class="font1"></span></p>
<a id="page_xii"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Application.vue?1f4f6ef4